// import { HttpClient } from '@angular/common/http';
// import { Injectable } from '@angular/core';
// import { UserService } from '../services/user.service';
// import { ActivatedRouteSnapshot, CanActivate, CanActivateChild, Router, RouterStateSnapshot } from '@angular/router';
// import { ApiUrls } from '../api-urls';
// import { ToastrService } from 'ngx-toastr';
// @Injectable({
//   providedIn: 'root'
// })
// export class AuthGuardService implements CanActivate,CanActivateChild {

//   ignoringRoutes=[
//     "/home/dashboard"
//   ]
//   permissions: any = []
//   userRole: any = []
//   constructor(
//     private http: HttpClient,
//     private userService: UserService,
//     private toastr: ToastrService,
//     private router: Router
//   ) { }


//   canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
//     let user = JSON.parse(localStorage.getItem('login'))
//     if (route.routeConfig.path == '') {
//       if (user) {
//         this.router.navigate(['/home/dashboard'])
//         return false;
//       }
//       return true;
//     } else {
//       if (!user) {
//         this.router.navigate([''])
//         return false;
//       }
//       return true;
//     }
//   }



//   canActivateChild(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
//     return this.userDocAccess(route);
//   }

//   async userDocAccess(route) {
//     // this.permissions = JSON.parse(localStorage.getItem('permissions'));
//     this.userRole = JSON.parse(localStorage.getItem('UserRoles'));
//     let user = JSON.parse(localStorage.getItem('login'))

//     console.log(" user doc")

//     if (user?.full_name !== 'Administrator') {
//       console.log(route?.data?.docType, " promise result ==== ")
//       if (route?.data?.docType) {


//         let res = await this.getPermDetails(route?.data?.docType)
//         console.log(res ," ===============")
//         // this.getPermDetails(route?.data?.docType).then((res: any) => {
//         //   console.log(" promise result ==== ", res)
//           if (res !== "No Permissions") {
//             localStorage.setItem("checkPermissions", JSON.stringify(res))
//             console.log(" Navigate")
//             return true;
//           } else {
//             this.toastr.error("No Permissions for "+ route?.data?.docType);
//             return false;
//           }
//         // })

//       } else {
//         return true;
//       }
//     } else {
//       return true;
//     }


//   }



//   getPermDetails(doctype_name) {

//     return new Promise((resolve, reject) => {

//       this.http.get(ApiUrls.permissions, {
//         params: {
//           name: doctype_name,
//           doctype: "DocType"
//         }
//       }).subscribe((res: any) => {
//         if (res?.docs) {
//           this.permissions = res?.docs;
//           let filteredRoles = res?.docs[0]?.permissions?.filter((ele) => this.userRole?.find((each) => each === ele?.role))
//           console.log("filteredRoles ===", filteredRoles, this.userRole)
//           if (filteredRoles?.length) {
//             const temp = filteredRoles.reduce((prev, nxt) => {
//               const keys = Object.keys(nxt);
//               keys.forEach((each) => {
//                 prev[each] = prev[each] || 0;
//                 prev[each] = nxt[each] > prev[each] ? nxt[each] : prev[each];
//               });
//               return prev;
//             }, {});
//             // return(temp)
//             console.log(" ============ temp ===== ", temp)
//             resolve(temp)



//             // let filteredDoc = this.permissions?.find((item: any) => item?.docName == route?.data?.docType)
//             // console.log("r===", filteredDoc, '-----', route)

//             // if (filteredDoc?.docs[0]?.permissions.length > 0) {
//             //   let filteredRoles = filteredDoc?.docs[0]?.permissions?.filter((ele) => this.userRole?.find((each) => each === ele?.role))
//             //   console.log("filteredRoles ===", filteredRoles, this.userRole)
//             //   if (filteredRoles.length) {
//             //     const temp = filteredRoles.reduce((prev, nxt) => {
//             //       const keys = Object.keys(nxt);
//             //       keys.forEach((each) => {
//             //         prev[each] = prev[each] || 0;
//             //         prev[each] = nxt[each] > prev[each] ? nxt[each] : prev[each];
//             //       });
//             //       return prev;
//             //     }, {});
//             //     // this.userService.docTypePermissions(temp)
//             //     localStorage.setItem("checkPermissions", JSON.stringify(temp))
//             //     return true
//             //   } else {
//             //     console.log(" ======= No permissions")
//             //     this.toastr.error("No Permissions")
//             //     return false;
//             //   }

//           } else {
//             // return("No Permissions")
//             resolve("No Permissions")

//           }
//         }
//       })
//     })
//   }



// }



import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, CanActivateChild, Router, RouterStateSnapshot } from '@angular/router';
import { ApiUrls, Doctypes } from '../api-urls';
import { ToastrService } from 'ngx-toastr';
import { catchError, map, switchMap } from 'rxjs/operators';
import { of } from 'rxjs';
@Injectable({
  providedIn: 'root'
})
export class AuthGuardService implements CanActivate, CanActivateChild {

  ignoringRoutes = [
    "/home/dashboard" 
  ]
  permissions: any = []
  userRole: any = []
  constructor(
    private http: HttpClient,
    private toastr: ToastrService,
    private router: Router
  ) { }


  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    const cookieValueFullName: any = decodeURIComponent(this.getCookie('full_name'));
    const cookieValueUserId = decodeURIComponent(this.getCookie('user_id'));
    let data_obj;
    if (cookieValueUserId) {
      const lowerCaseFullName = cookieValueFullName.toLowerCase();

      if (lowerCaseFullName !== 'guest' && lowerCaseFullName !== 'administrator' && lowerCaseFullName !== 'null' && lowerCaseFullName !== '') {
        data_obj = this.getUserList(cookieValueFullName, cookieValueUserId);
      }
    }

    const cookieValueUserSSO = decodeURIComponent(this.getCookie('sso_user'));
    if (cookieValueUserSSO.toLocaleLowerCase() == 'true') {
      this.deleteCookie('sso_user');
      setTimeout(() => {
        window.location.reload()
      }, 1500)
    }
    let user = data_obj ? JSON.parse(localStorage.getItem('login')) : ''
    if (route.routeConfig.path == '') {
      if (user) {
        this.router.navigate(['/home'])
        return false;
      }
      return true;
    } else {
      if (!user) {
        this.router.navigate([''])
        return false;
      }
      return true;
    }
  }

  lastCheckedUrl: string = '';

  // canActivateChild(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
  //   return this.userDocAccess(route, state);
  // }

  canActivateChild(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    // console.log("state.url === ", state.url)

    // console.log("ignoring routes sdfghj== ", this.ignoringRoutes)
    // Avoid unnecessary checks for ignored routes
    if (this.ignoringRoutes.includes(state.url)) {
      return true;
    }

    // Restrict duplicate checks
    // if (this.lastCheckedUrl === state.url) {
    //   console.log("lastCheckedUrl === ", this.lastCheckedUrl)
    //   return true;
    // }
    // this.lastCheckedUrl = state.url;

    let xyz = this.userDocAccess(route, state)
    return xyz;
  }

  userDocAccess(route, stateUrl) {
    // this.permissions = JSON.parse(localStorage.getItem('permissions'));
    // this.userRole = JSON.parse(localStorage.getItem('UserRoles'));
    let user = JSON.parse(localStorage.getItem('login'))
    if (user?.full_name !== 'Administrator') {
      // console.log(" user doc ==== ")
      let ignoreRouteExist = this.ignoringRoutes?.some(res => stateUrl?.url?.includes(res))
      // console.log("ignoreRouteExist === ", ignoreRouteExist)
      if (ignoreRouteExist) return true;
      return this.getUserPermissionListData()?.then((res: any) => {
        let temp = res.some((el: any) => {
          // console.log("el ++++ ",el)
          if ((stateUrl.url.includes(el?.route_link)) && el.read) {
            localStorage.setItem("checkPermissions", JSON.stringify(el))
          }
          // console.log(el?.route_link , "  ============  ",stateUrl.url)
          return ((stateUrl.url.includes(el?.route_link)) && el.read)
        })
        // console.log("temp === ", temp)
        if (!temp) this.toastr.error('Not Authorised')
        return temp;
      })
    } else {
      return true;
    }


  }

  getUserPermissionListData() {
    const user = JSON.parse(localStorage.getItem('login'));
    if (!user?.rolesFilter?.length) {
      this.toastr.error("User has no roles");
      return Promise.reject("User has no roles");
    }
    return this.http.get(`${ApiUrls.roles_permission}/${user.rolesFilter[0]}`, {
      params: { fields: JSON.stringify(['permission_list']) }
    }).toPromise()
      .then((res: any) => res?.data?.permission_list || Promise.reject("No permissions found"))
      .catch((error) => {
        this.toastr.error(error === "No permissions found" ? error : "Failed to fetch permissions");
        return Promise.reject(error);
      });
  }




  getCookie(name) {
    const nameEQ = `${name}=`;
    const cookies = document.cookie.split(';');
    for (let cookie of cookies) {
      let c = cookie.trim();
      if (c.indexOf(nameEQ) === 0) {
        return c.substring(nameEQ.length, c.length);
      }
    }
    return null;
  }


  getUserList(userName: string, formData: string) {

    if (userName === 'guest') return;
    // Check if login and company data already exist in localStorage
    let login_details = localStorage.getItem('login') ? JSON.parse(localStorage.getItem('login')) : null;
    let company_details = localStorage.getItem('company') ? JSON.parse(localStorage.getItem('company')) : null;

    // If both data are already available, skip API calls
    if (login_details && company_details) {
      console.log("Using cached data from localStorage.");
      return of({ login: login_details, company: company_details }).pipe(
        map((data) => {
          console.log("Cached login and company details:", data);
          return data;
        })
      ).subscribe((result) => console.log('Final result (cached):', result));
    }


    const queryParams: any = { filters: [] };
    queryParams.filters.push(['full_name', 'like', `%${userName}%`]);

    const isEmail = /\S+@\S+\.\S+/.test(formData);
    queryParams.filters.push([isEmail ? 'email' : 'username', 'like', `%${formData}%`]);
    queryParams.filters = JSON.stringify(queryParams.filters);

    return this.http.get(`${ApiUrls.users}`, { params: queryParams }).pipe(
      switchMap((res: any) => res?.data?.length ? this.http.get(`${ApiUrls.users}/${res.data[0].name}`) : this.handleError('User not found')),
      switchMap((userData: any) => {
        if (!userData?.data) return this.handleError('User data not found');

        let roles = userData.data.roles.map((each: any) => each.role).filter((role: string) => role.includes('ezy'));
        userData.data['rolesFilter'] = roles;
        localStorage.setItem('login', JSON.stringify(userData.data));
        this.getUserRoles()
        return this.http.get(ApiUrls.company);
      }),
      switchMap((res: any) => res?.data?.length ? this.http.get(`${ApiUrls.company}/${res.data[0].name}`) : this.handleError('Company not found')),
      map((companyData: any) => {
        if (!companyData?.data) return this.handleError('Company data not found');

        localStorage.setItem('company', JSON.stringify(companyData.data));
        return companyData.data;
      }),
      catchError((error) => this.handleError('An error occurred', error))
    ).subscribe((result) => console.log('Final result:', result));
  }

  getUserRoles(): void {
    this.http.get(ApiUrls.userRoles).subscribe((responce: any) => {
      let userRoles = responce.message.data.filter((each: any) => each.includes('ezy'))
      localStorage.setItem("UserRoles", JSON.stringify(userRoles))
    })
  }

  private handleError(message: string, error: any = null) {
    // this.toastr.error(message);
    if (error) console.error(error);
    return of(null);
  }

  deleteCookie(cookieName) {
    document.cookie = `${cookieName}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
  }
}





